import { render, staticRenderFns } from "./ProductApprovalFormWizard.vue?vue&type=template&id=0f9cc34f"
import script from "./ProductApprovalFormWizard.vue?vue&type=script&lang=js"
export * from "./ProductApprovalFormWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports